export const userManage = {
  tableLabel: [],
  listTypeInfo: {},
};

export const roleManage = {
  tableLabel: [],
  fieldList: [
    {
      label: "角色名称",
      type: "input",
      value: "roleName",
    },
  ],

  listTypeInfo: {},
};
